module.exports = __webpack_public_path__ + "static/media/drop_file_upload.5df29fd9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/swipe/drop_file_upload.jpg
// module id = 259
// module chunks = 0